export const FORM = 'form';
export const THANK_YOU = 'thankYou';
export const PAYMENT_LINK = 'paymentLink';
export const SCHEDULING_PAGE = 'schedulingPage';
export const STEPS = [FORM, THANK_YOU, PAYMENT_LINK, SCHEDULING_PAGE];